import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = [
    'addOtherButton',
    'otherOption',
    'otherOptionInput',
    'deleteButton',
  ];

  static values = {
    minOptions: Number,
  };

  connect() {
    this.updateDeleteButtonVisibility();
    this.updateOtherButtonVisibility();
  }

  updateDeleteButtonVisibility(event) {
    const sortableItems = this.element.querySelectorAll('li[id]');
    const itemCount = event?.detail?.itemCount ?? sortableItems.length;
    const shouldHide = itemCount <= this.minOptionsValue;

    this.deleteButtonTargets.forEach((button) => {
      button.hidden = shouldHide;
    });
  }

  addOtherOption(event) {
    event.preventDefault();

    if (!this.hasOtherOptionTarget) return;

    this.otherOptionTarget.hidden = false;
    this.otherOptionInputTarget.checked = true;
    this.updateOtherButtonVisibility();
  }

  removeOtherOption(event) {
    event.preventDefault();

    if (this.hasOtherOptionTarget) {
      this.otherOptionTarget.hidden = true;
      this.otherOptionInputTarget.checked = false;
    }

    this.updateOtherButtonVisibility();
  }

  updateOtherButtonVisibility() {
    if (!this.hasAddOtherButtonTarget) return;

    const isOtherOptionVisible =
      this.hasOtherOptionTarget && !this.otherOptionTarget.hidden;
    this.addOtherButtonTarget.hidden = isOtherOptionVisible;
  }
}
